<script lang="ts">
  import {HttpResponse, request} from './httphelper';
  import { onMount } from 'svelte';
  import Evaluate from './Evaluate.svelte'
  import Evaluated from './Evaluated.svelte'
  import Matches from './Matches.svelte';
  let isLoggedIn = false;
  let username = '';
  let password = '';
  let error = undefined;
  let tab = window.location.pathname;

  onMount(async () => {
    const response = await request<any>(new Request(`/login.php`));
    if (response.ok && response.apiResponseStatus == 0) {
      isLoggedIn = true;
    }
  });

  async function submit(event) {
    isLoggedIn = false;
    error = undefined;
		const response = await request<any>(new Request(`/login.php`,
    {
      method : 'POST',
      body:JSON.stringify({
        username : username,
        password : password
      })
    }
    ));
    if (!response.ok || response.apiResponseStatus != 0) {
      error = 'Fehler beim Einloggen';
      return ;
    }
    else {
      isLoggedIn = true;
    }
	}
</script>

<svelte:head>
  <title>Namensfindung</title>
</svelte:head>
<div class="container">
  <header><h1>Namensfindung</h1></header>
  <main>
  {#if !isLoggedIn}
    <h2>Einloggen</h2>
    <div id="login">
      <form on:submit|preventDefault={submit} id="form_login">
        <label for="username"><b>Benutzer</b></label><br><input type="text" required bind:value={username} autocomplete="username"><br>
        <label for="password"><b>Passwort</b></label><br><input type="password" required bind:value={password} autocomplete="current-password"><br>
        <button type="submit" id="btn_submit_login" class="btn">Einloggen</button>
      </form>
    </div>
  {:else if tab=="/evaluated"}
    <Evaluated bind:error></Evaluated>
  {:else if tab=="/matches"}
    <Matches bind:error></Matches>
  {:else}
    <Evaluate bind:error></Evaluate>
  {/if}
  {#if error}
    <p style="color:red;">{error}</p>
  {/if}
  </main>
  <footer>
    <nav><a href="/evaluate">Swipen</a> | <a href="/evaluated">Bewertet</a> | <a href="/matches">Treffer</a></nav>
  </footer>
  </div>
